import {NodeProps} from 'reactflow';

import RouterNodeRenderer from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/RouterNodeRenderer';
import StopNodeRenderer from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/StopNodeRenderer';
import TaskSchemaNodeRenderer from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/TaskSchemaNodeRenderer';
import {ProcessFlowchartNodeType} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';

import LogicNodeSidepanelSection from './left-sidepanel/LogicNodeSidepanelSection';
import {NodeSidepanelSectionProps} from './left-sidepanel/NodeSidepanelSection';
import TaskNodeSidepanelSection from './left-sidepanel/TaskNodeSidepanelSection';

export enum TaskSchemaNodeSection {
  INPUTS = 'Inputs',
  OUTPUTS = 'Outputs',
}

export const TASK_SCHEMA_NODE_SECTION_PREFIX: Record<TaskSchemaNodeSection, string> = {
  [TaskSchemaNodeSection.INPUTS]: 'input',
  [TaskSchemaNodeSection.OUTPUTS]: 'output',
};

export const NODE_SECTION_PREFIX_TO_TASK_SCHEMA_NODE_SECTION: Record<string, TaskSchemaNodeSection> =
  Object.entries(TASK_SCHEMA_NODE_SECTION_PREFIX).reduce(
    (acc, [key, value]) => {
      acc[value] = key as TaskSchemaNodeSection;
      return acc;
    },
    {} as Record<string, TaskSchemaNodeSection>
  );

export enum NodeTransitionPosition {
  SOURCE = 'source',
  TARGET = 'target',
}

export interface NodeTransitionPositionConfig {
  nodeTransitionPosition: NodeTransitionPosition;
  indexInNodeTransitionPosition: number;
}

export enum ProcessFlowchartNodeSection {
  TASK_SCHEMAS = 'TASK_SCHEMAS',
  LOGIC = 'LOGIC',
  PIPELINES = 'PIPELINES',
}

export const NODE_TYPE_TO_NAME: Record<ProcessFlowchartNodeType, string> = {
  [ProcessFlowchartNodeType.TASK_SCHEMA_NODE]: 'Task',
  [ProcessFlowchartNodeType.ROUTER_NODE]: 'Router',
  [ProcessFlowchartNodeType.STOP_NODE]: 'Stop',
};

export const NODE_TYPE_TO_SECTION: Record<ProcessFlowchartNodeType, ProcessFlowchartNodeSection> = {
  [ProcessFlowchartNodeType.TASK_SCHEMA_NODE]: ProcessFlowchartNodeSection.TASK_SCHEMAS,
  [ProcessFlowchartNodeType.ROUTER_NODE]: ProcessFlowchartNodeSection.LOGIC,
  [ProcessFlowchartNodeType.STOP_NODE]: ProcessFlowchartNodeSection.LOGIC,
};

export const NODE_TYPE_TO_RENDERER: Record<ProcessFlowchartNodeType, (props: NodeProps) => JSX.Element> = {
  [ProcessFlowchartNodeType.TASK_SCHEMA_NODE]: TaskSchemaNodeRenderer,
  [ProcessFlowchartNodeType.ROUTER_NODE]: RouterNodeRenderer,
  [ProcessFlowchartNodeType.STOP_NODE]: StopNodeRenderer,
};

export const NODE_SECTION_TO_HEADER_TITLE: Record<ProcessFlowchartNodeSection, string> = {
  [ProcessFlowchartNodeSection.TASK_SCHEMAS]: 'Task schemas',
  [ProcessFlowchartNodeSection.LOGIC]: 'Logic',
  [ProcessFlowchartNodeSection.PIPELINES]: 'Pipelines',
};

export const NODE_SECTION_TO_RENDERER: Record<
  ProcessFlowchartNodeSection,
  (props: NodeSidepanelSectionProps) => JSX.Element | null
> = {
  [ProcessFlowchartNodeSection.TASK_SCHEMAS]: TaskNodeSidepanelSection,
  [ProcessFlowchartNodeSection.LOGIC]: LogicNodeSidepanelSection,
  [ProcessFlowchartNodeSection.PIPELINES]: () => null,
};
